import common from "@/lang/en/common";
import session from "@/lang/en/session";
import error from "@/lang/en/error";
import category from '@/lang/en/category';
import nav from '@/lang/en/nav';
import footer from '@/lang/en/footer';
import support from '@/lang/en/support';
import homeview from "@/lang/en/homeview";
import modal from "@/lang/en/modal";
import activityview from "@/lang/en/activityview";
import rewardsview from "@/lang/en/rewardsview";
import misc from "@/lang/en/misc";
import datepicker from "@/lang/en/datepicker";
import accountview from "@/lang/en/accountview";
import affinities from "@/lang/en/affinity";
import videosview from "@/lang/en/videosview";
import subscriptionflow from "@/lang/en/subscriptionflow";
import renewview from "@/lang/en/renewview";
import referralview from "@/lang/en/referralview";

export default {
  ...common,
  ...session,
  ...error,
  ...category,
  ...nav,
  ...footer,
  ...support,
  ...homeview,
  ...activityview,
  ...rewardsview,
  ...modal,
  ...misc,
  ...datepicker,
  ...accountview,
  ...affinities,
  ...videosview,
  ...subscriptionflow,
  ...renewview,
  ...referralview,
};
